import { normalizeBodyHeaderPaging } from './subMatTemplateTocOrder';

/**
 * FE UI 키: folder:{id}::{page}::a4|raw
 * API/DB 키: folder:{id}::{page} | extra:{index}::{page}
 */

/** DB/API → UI (현재 bodyHeaderPaging 프레임 붙임) */
export const stampPlacementsToUi = (apiPlacements, bodyHeaderPaging) => {
  const frame = normalizeBodyHeaderPaging(bodyHeaderPaging) ? 'a4' : 'raw';
  const out = {};
  Object.entries(apiPlacements || {}).forEach(([key, pos]) => {
    if (!pos || pos.xPt == null || pos.yPt == null) return;
    const parts = String(key).split('::');
    if (parts.length >= 3 && (parts[2] === 'a4' || parts[2] === 'raw')) {
      out[key] = { xPt: Number(pos.xPt), yPt: Number(pos.yPt) };
      return;
    }
    if (parts.length >= 2) {
      out[`${parts[0]}::${parts[1]}::${frame}`] = { xPt: Number(pos.xPt), yPt: Number(pos.yPt) };
    }
  });
  return out;
};

/**
 * UI → API/DB.
 * extras: 별도첨부 있을 때만 (메일전송). 템플릿 저장은 보통 [].
 */
export const stampPlacementsToApi = (uiPlacements, extras, bodyHeaderPaging) => {
  const frame = normalizeBodyHeaderPaging(bodyHeaderPaging) ? 'a4' : 'raw';
  const includedExtras = (extras || []).filter((e) => e && e.included !== false && e.file);
  const extraIdToIndex = {};
  includedExtras.forEach((e, i) => {
    extraIdToIndex[e.id] = i;
  });
  const out = {};
  Object.entries(uiPlacements || {}).forEach(([key, pos]) => {
    if (!pos || pos.xPt == null || pos.yPt == null) return;
    const parts = String(key).split('::');
    if (parts.length < 3 || parts[2] !== frame) return;
    const [sourceKey, pageStr] = parts;
    let apiKey = null;
    if (sourceKey.startsWith('folder:')) {
      apiKey = `${sourceKey}::${pageStr}`;
    } else if (sourceKey.startsWith('extra:')) {
      const id = sourceKey.slice('extra:'.length);
      const idx = extraIdToIndex[id];
      if (idx == null) return;
      apiKey = `extra:${idx}::${pageStr}`;
    }
    if (apiKey) {
      out[apiKey] = { xPt: Number(pos.xPt), yPt: Number(pos.yPt) };
    }
  });
  return out;
};
